import BaseCheckbox from "../baseComponents/baseCheckbox";
import BaseHyperlink from "../baseComponents/baseHyperlink";
import BaseParagraph from "../baseComponents/baseParagraph";
import useColors from "../customHooks/useColors";
import { useSelector } from "react-redux";
import BaseRequiredMark from "../baseComponents/BaseRequiredMark";

const DataProcessingCheckbox = ({
  value,
  onChange = () => {},
  disabled = false,
}) => {
  const [currentColors] = useColors();

  const systemState = useSelector((state) => state.systemState);



  const dataProcessingLink = systemState.settings.data_processing_link

  return (
    <BaseCheckbox disabled={disabled} value={value} onChange={onChange}>
      <BaseParagraph>acceptDataProcessing</BaseParagraph>
      <BaseHyperlink href={dataProcessingLink}>
        dataProcessing
      </BaseHyperlink>
      <BaseParagraph>acceptDataProcessing2</BaseParagraph>
      {systemState.settings.req_permission2 && <BaseRequiredMark />}
    </BaseCheckbox>
  );
};

export default DataProcessingCheckbox;
